"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Phone, Calendar, MessageSquare } from "lucide-react";
export default function HowItWorks() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const steps = [{
    number: 1,
    title: "Anruf empfangen",
    description: "Ihr KI-Rezeptionist nimmt eingehende Anrufe automatisch entgegen",
    icon: Phone
  }, {
    number: 2,
    title: "Termin buchen",
    description: "Termine werden direkt in Ihr System eingetragen",
    icon: Calendar
  }, {
    number: 3,
    title: "Anfrage bearbeiten",
    description: "Kundenanfragen werden rund um die Uhr professionell beantwortet",
    icon: MessageSquare
  }];
  return <section ref={sectionRef} className="relative bg-background py-16 md:py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,hsl(0,0%,85%)_1px,transparent_1px),linear-gradient(to_bottom,hsl(0,0%,85%)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-30 pointer-events-none" />

      <div className="container relative mx-auto px-6 max-w-7xl">
        {}
        <div className={`text-center mb-12 md:mb-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Wie es funktioniert?
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Drei einfache Schritte zu Ihrer intelligenten Telefonzentrale
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <div key={step.number} data-index={i} className={`relative flex flex-col items-center text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`} style={{
            transitionDelay: isVisible ? `${i * 200}ms` : "0ms"
          }}>
                {}
                <div className="relative mb-6">
                  <div className="w-24 h-24 rounded-full bg-primary/10 border-2 border-primary flex items-center justify-center shadow-soft">
                    <Icon className="w-10 h-10 text-primary" strokeWidth={1.5} />
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-primary text-foreground-primary flex items-center justify-center font-bold text-sm shadow-medium">
                    {step.number}
                  </div>
                </div>

                {}
                <h3 className="text-xl md:text-2xl font-display font-semibold text-foreground mb-3">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-base leading-relaxed max-w-xs">
                  {step.description}
                </p>

                {}
                {i < steps.length - 1 && <div className="hidden md:block absolute top-12 left-[calc(50%+3rem)] w-[calc(100%-6rem)] h-0.5 bg-border" />}
              </div>;
        })}
        </div>
      </div>
    </section>;
}